import { render, staticRenderFns } from "./Seller.vue?vue&type=template&id=c4f67724&scoped=true"
import script from "./Seller.vue?vue&type=script&lang=js"
export * from "./Seller.vue?vue&type=script&lang=js"
import style0 from "./Seller.vue?vue&type=style&index=0&id=c4f67724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../.npm/_npx/14f5bcddd9f17f34/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f67724",
  null
  
)

export default component.exports